import React from 'react'
import { FormField } from '../../../../Common/FormField'
import styles from './CompanyNameWithPeriod.module.css'

interface CompanyNameFieldsProps {
    companyName: string
    brandName: string
    storeName: string
    setCompanyName: (value: string) => void
    setBrandName: (value: string) => void
    setStoreName: (value: string) => void
}

export const CompanyNameFields = ({
    companyName,
    brandName,
    storeName,
    setCompanyName,
    setBrandName,
    setStoreName,
}: CompanyNameFieldsProps) => (
    <div className={styles.companyFields}>
        <div className={styles.fieldWrapper}>
            <div className={styles.labelWithBadge}>
                <span className={styles.label}>会社名</span>
            </div>
            <FormField
                label=""
                placeholder=" (例) 株式会社フーズラボ"
                value={companyName}
                onChange={setCompanyName}
            />
        </div>

        <div className={styles.fieldWrapper}>
            <div className={styles.labelWithBadge}>
                <span className={styles.label}>ブランド・系列名</span>
            </div>
            <FormField
                label=""
                placeholder=" (例) フーズラボバーガー"
                value={brandName}
                onChange={setBrandName}
            />
        </div>

        <div className={styles.fieldWrapper}>
            <div className={styles.labelWithBadge}>
                <span className={styles.label}>店舗名</span>
                <span className={styles.optionalBadge}>任意</span>
            </div>
            <FormField
                label=""
                placeholder=" (例) 渋谷店"
                value={storeName}
                onChange={setStoreName}
            />
        </div>
    </div>
)

